(() => {
  new Swiper(".employee-slider__slider", {
    slidesPerView: 1,
    //slidesPerGroup: 1,
    spaceBetween: 25,
    autoplay: {
        delay: 5000,
    },
    navigation: {
      nextEl: ".swiper-button-next-employee-slider",
      prevEl: ".swiper-button-prev-employee-slider",
    },       
    breakpoints: {
        768: {
            slidesPerView: 3,
            autoplay: false,
        },
        1024: {
            slidesPerView: 3,
            autoplay: false,
        }
    }
  });
})();
